import { DialogPositioningBehavior, DialogType } from '@tableau/widgets';

import { ModalInstance, ReactModalService } from '~commonInfra/dialogs/ReactModalService';

import { Messages } from '../../codegen/Localize';
import { IDataSourceInfo } from '../../datasource/models/IDataSourceInfo';
import { DataSources } from '../../datasource/resources/Datasources';
import { PublishFlowSuccessDialog } from '../components/PublishFlowSuccessDialog';
import { FlowDetailInfo } from '../models/FlowInfo';

export namespace PublishFlowAction {

  export function handlePublishedFlow(flow: FlowDetailInfo, publishedDatasourceUrlNames: string[]): Promise<any> {
    if(publishedDatasourceUrlNames.length > 0) {
      DataSources.getPublishedByUrlNames(publishedDatasourceUrlNames)
    .then((result => {
      const datasourceInfos = result.items;
      return displayPublishFlowSuccessDialog(flow.name, datasourceInfos);
    }));
    } else {
      return displayPublishFlowSuccessDialog(flow.name);
    }
  }

  function displayPublishFlowSuccessDialog(flowName: string, datasourceInfos?: IDataSourceInfo[]): Promise<any> {
    const dialogProps = {
      flowName: flowName,
      datasourceInfos: datasourceInfos,
    };

    const modalInstance: ModalInstance = ReactModalService.open({
      title: Messages.publishDatasourceSuccessDialogTitleComplete(),
      type: DialogType.NormalWithTitleBar,
      positioningBehavior: DialogPositioningBehavior.Centered,
      dialogContent: PublishFlowSuccessDialog(dialogProps),
      showCloseButton: true,
      dialogWidth: 450,
      dismissDialogOnCloseAction: true,
    });

    return Promise.resolve(modalInstance.result).finally(modalInstance.dismiss);
  }
}
